import { Module } from '@nestjs/common';
import { LotesModule } from 'src/lotes/lotes.module';
import { AuditModule } from 'src/audit/audit.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { QueuesModule } from 'src/queues/queues.module';
import { MiddlewareSifenModule } from 'src/middleware-sifen/middleware-sifen.module';
import { VendedoresCobradoresModule } from 'src/vendedores-cobradores/vendedores-cobradores.module';
import { winstonConfig } from '../common/logger/winston.config';
import { NotaCreditosController } from './nota-creditos.controller';
import { NotaCreditosService } from './nota-creditos.service';

@Module({
  imports: [PrismaModule, QueuesModule, AuditModule, LotesModule, MiddlewareSifenModule, VendedoresCobradoresModule],
  controllers: [NotaCreditosController],
  providers: [NotaCreditosService],
  exports: [NotaCreditosService],
})
export class NotaCreditosModule {}
